export default __webpack_public_path__ + "static/media/CheckBoxUnchecked.707e8b38.svg";